import React from 'react';
import PropTypes from 'prop-types';
import {Popper, Arrow} from 'react-popper';
import {ThemeContext} from '../';

const Popover = (props) => {
  const {title, placement, children, theme} = props;

  return (
    <ThemeContext.Consumer>
      {(template) => {
        const styles = {
          backgroundColor: template[`${theme}Color`],
        };
        return (
          <Popper placement={placement} className="popover">
            {title &&
              <div style={styles} className="popover__title">{title}</div>
            }
            <div className="popover__content">
              {children}
            </div>
            <Arrow className="popover__arrow"/>
          </Popper>
        );
      }
      }
    </ThemeContext.Consumer>
  );
};

Popover.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
};

Popover.defaultProps = {
  placement: 'top',
  theme: 'primary',
};

export default Popover;
